import { useState, useEffect } from 'react'
import dynamic from 'next/dynamic'
import { useLoginData } from 'utils/api/hooks'

const DynamicProcessingVerifyCheck = dynamic(
  () => import('./ProcessingVerifyCheck'),
  { ssr: false }
)

const SyDealCustomerVerifyProvider = ({ children }) => {
  const { me, appId, token, isLoading: isAuthLoading } = useLoginData()

  const [processingVerifyCheck, setProcessingVerifyCheck] = useState(false)
  useEffect(() => {
    if (isAuthLoading || !me) {
      return
    }
    setProcessingVerifyCheck(true)
  }, [isAuthLoading])

  return (
    <>
      {children}
      {processingVerifyCheck && <DynamicProcessingVerifyCheck />}
    </>
  )
}

export default SyDealCustomerVerifyProvider
